import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Dropdawn() {
  const navigate = useNavigate();
  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    navigate("/signin");
  };
  return (
    <div className="flex flex-col dropdawn">
      <ul className="flex flex-col gap-2">
        <li>
          <Link>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5V12.5Z"
                stroke="#111111"
                strokeOpacity="0.4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.3517 8.66234L15.4375 6.454L16.6667 4.99984L15 3.33317L13.5542 4.569L11.2984 3.6415L10.7792 1.6665H9.15085L8.62419 3.66734L6.42002 4.5965L5.00002 3.33317L3.33335 4.99984L4.54419 6.49067L3.64419 8.70484L1.66669 9.1665V10.8332L3.66752 11.379L4.59669 13.5832L3.33335 14.9998L5.00002 16.6665L6.49252 15.4498L8.66419 16.3432L9.16669 18.3332H10.8334L11.3367 16.344L13.5459 15.429C13.9142 15.6923 15 16.6665 15 16.6665L16.6667 14.9998L15.43 13.5415L16.345 11.3315L18.3334 10.8148V9.1665L16.3517 8.66234V8.66234Z"
                stroke="#111111"
                strokeOpacity="0.4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Sozlama
          </Link>
        </li>
        <li>
          <Link onClick={logout}>
            <svg
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.8333 9L10.3333 6.5M7 9H12.8333H7ZM12.8333 9L10.3333 11.5L12.8333 9Z"
                stroke="#111111"
                strokeOpacity="0.4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.8334 4V3.16667C12.8334 2.72464 12.6578 2.30072 12.3452 1.98816C12.0326 1.67559 11.6087 1.5 11.1667 1.5H2.83335C2.39133 1.5 1.9674 1.67559 1.65484 1.98816C1.34228 2.30072 1.16669 2.72464 1.16669 3.16667V14.8333C1.16669 15.2754 1.34228 15.6993 1.65484 16.0118C1.9674 16.3244 2.39133 16.5 2.83335 16.5H11.1667C11.6087 16.5 12.0326 16.3244 12.3452 16.0118C12.6578 15.6993 12.8334 15.2754 12.8334 14.8333V14"
                stroke="#111111"
                strokeOpacity="0.4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Chiqish
          </Link>
        </li>
      </ul>
    </div>
  );
}
